import React, { useEffect, useState } from "react";
import API from '../Services/Discount'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import DiscountList from "../Discount/DiscountList";
const Discount = () => {
    const [name, setName] = useState("")
    const [date, setDate] = useState("")
    const [discountType, setDiscountType] = useState("")
    const [discountPer, setDiscountPer] = useState("")
    const [error, setError] = useState({});

    const handleSelectChange = (e, fieldName) => {
        const value = e.target.value;
        setDiscountType(value);
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        if (fieldName === "discountType") {
            //  setDiscountPer(value);
        }
    };


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "date":
                setDate(value);
                break;
            case "discountPer":
                setDiscountPer(value);
                break;
            default:
                break;
        }
    };
    const validateFields = () => {
        const errors = {};
        if (!(name?.trim())) errors.name = "Name is required";
        if (!(discountType?.trim())) errors.discountType = "Discount Type is required";

        const priceRegex = /^\d+(\.\d{1,2})?$/;

        if (!discountPer || String(discountPer).trim() === "") {
            errors.discountPer = "Discount amount is required";
        } else if (!priceRegex.test(String(discountPer))) {
            errors.discountPer = "Discount amount must be a valid number (e.g., 100 or 100.50)";
        } else if (discountType === "percentage" && parseFloat(discountPer) > 100) {
            errors.discountPer = "Discount percentage cannot exceed 100%";
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };


    const addDiscountData = async () => {
        if (!validateFields()) return;
        const formattedDate = date === "" ? null : date;
        const payload = {
            name: name,
            type: discountType,
            discount: discountPer,
            end_date: formattedDate
        }
        try {
            const response = await API.addDiscounts(payload);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Discount successful!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Discount failed.");
            }
        } catch (error) {
            if (error.response) {
                // console.error("Response data:", error.response.data);
                const errorMessage =
                    error.response.data?.message || `Error: ${error.response.status}`;
                toast.error(errorMessage);
            }

            else if (error.response.status === 404) {
                toast.error('Resource not found');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please try again later.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addDiscountData();

    };

    const handleCancel = () => {
        window.location.reload();
        setName('');
        setDate('');
        setDiscountType('')
        setDiscountPer('')

    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Discount will always in rupees (<span className="mdi mdi-currency-rupee"></span>)</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtName"
                                            placeholder="Name"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {error?.name && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">End Date </label>
                                        <input
                                            type="Date"
                                            className="form-control"
                                            id="txtDate"
                                            placeholder="Date"
                                            value={date}
                                            onChange={(e) => handleFieldChange(e, "date")}
                                        />
                                        {error?.date && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.date}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="name">Discount Type <span style={{ color: "red" }}>*</span></label>
                                        <select
                                            className="form-select"
                                            id="ddtime"
                                            value={discountType}
                                            onChange={(e) => handleSelectChange(e, "discountType")} >
                                            <option value="">Select Discount Type</option>
                                            <option value="percentage">Discount %</option>
                                            <option value="amount">Discount Amount</option>
                                        </select>
                                        {error?.discountType && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.discountType}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {discountType === "percentage" && (
                                        <div className="form-group">
                                            <label htmlFor="discountPercentage">Discount % <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtDiscountper"
                                                placeholder="Enter Discount %"
                                                value={discountPer}
                                                onChange={(e) => handleFieldChange(e, "discountPer")}
                                            />
                                            {error?.discountPer && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.discountPer}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {discountType === "amount" && (
                                        <div className="form-group">
                                            <label htmlFor="discountAmount">Discount Amount (<span className="mdi mdi-currency-rupee"></span>)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtDiscountamount"
                                                placeholder="Enter Discount Amount"
                                                value={discountPer}
                                                onChange={(e) => handleFieldChange(e, "discountPer")}
                                            />
                                            {error?.discountPer && (
                                                <span className="text-danger" style={{ fontSize: "12px" }}>
                                                    {error.discountPer}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="mt-3">
                                <button
                                    onClick={handleSubmit}
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Submit
                                </button>
                                <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DiscountList />
            <ToastContainer />
        </div>

    );
};

export default Discount;